// Roteiro por tipo de ação (o que fazer). Espelha NOTIFICATION_ACTION_PLANS das
// notificações: resumo + passos + para onde ir.
const ACTION_PLANS = {
  COBRANCA_PREVENTIVA: {
    summary: "Contato antes do vencimento",
    steps: [
      "Envie lembrete (WhatsApp/e-mail) com o boleto e a data de vencimento.",
      "Ofereça segunda via e formas de pagamento alternativas.",
      "Registre o retorno do aluno para o próximo ciclo."
    ],
    route: "/app/predicao",
    routeLabel: "Ver análise de inadimplência"
  },
  COBRANCA_VENCIDA_1_29: {
    summary: "Lembrete amigável de atraso",
    steps: [
      "Envie aviso de atraso com a segunda via do boleto.",
      "Confirme se houve problema no pagamento (boleto perdido, dados errados).",
      "Sem retorno em 7 dias, ligue."
    ],
    route: "/app/alunos-inadimplentes",
    routeLabel: "Ver alunos inadimplentes"
  },
  COBRANCA_VENCIDA_30_89: {
    summary: "Negociação individual",
    steps: [
      "Ligue e proponha parcelamento ou desconto de juros.",
      "Formalize o acordo no sistema acadêmico (tipo de cobrança 'Acordo').",
      "Acompanhe a primeira parcela do acordo."
    ],
    route: "/app/alunos-inadimplentes",
    routeLabel: "Ver alunos inadimplentes"
  },
  COBRANCA_VENCIDA_90: {
    summary: "Acordo formal ou cobrança externa",
    steps: [
      "Reúna o histórico de contatos anteriores.",
      "Proponha acordo formal com entrada; avalie encaminhamento externo.",
      "Verifique a situação acadêmica do aluno (risco de evasão)."
    ],
    route: "/app/alunos-inadimplentes",
    routeLabel: "Ver alunos inadimplentes"
  },
  ACORDO_DESCUMPRIDO: {
    summary: "Retomar o acordo antes que se perca",
    steps: [
      "Contato imediato: acordo descumprido costuma virar evasão.",
      "Renegocie a parcela vencida mantendo o restante do acordo.",
      "Registre o novo compromisso."
    ],
    route: "/app/alunos-inadimplentes",
    routeLabel: "Ver alunos inadimplentes"
  },
  EVASAO_RISCO_ALTO: {
    summary: "Contato do coordenador com o aluno",
    steps: [
      "Frequência baixa: convoque para conversa e ofereça reposição/tutoria.",
      "Nota abaixo do limiar: encaminhe para reforço ou monitoria.",
      "Motivo financeiro: envolva o financeiro para negociação."
    ],
    route: "/app/possiveis-evasores",
    routeLabel: "Ver possíveis evasores"
  },
  REMATRICULA: {
    summary: "Campanha de rematrícula",
    steps: [
      "Dispare comunicação de rematrícula para a lista.",
      "Priorize quem também aparece em risco de evasão ou inadimplência.",
      "Acompanhe a conversão até o fim do período."
    ],
    route: "/app/academico",
    routeLabel: "Ver painel acadêmico"
  },
  DADOS_DEFASADOS: {
    summary: "Atualizar os dados importados",
    steps: [
      "Exporte o faturamento e os alunos atualizados do sistema acadêmico.",
      "Envie em Importar dados (Importação Inteligente aceita o arquivo sem ajustes).",
      "As predições e esta fila são recalculadas na sequência."
    ],
    route: "/app/importar-dados",
    routeLabel: "Ir para importações"
  }
};

export const getActionPlan = (type) => ACTION_PLANS[type] || null;
